export function formatPlaceholder(selected_providers) {
  return selected_providers.length > 0
    ? `${selected_providers.length} selected`
    : 'All doctors'
}
